import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { Col, Grid, NarrowContainer } from "components/Containers";
import { breakpoints, colors, fontSize } from "style";
import { H1, MarketingHeader } from "components/Text";
import CheckList from "components/CheckList";
import Image from "components/Image";
import Hero from "assets/images/hero-device-1300x1898-c-center.png";
import { getBrandConfig } from "constants/brands";
import Background from "assets/images/main-hero-bg.webp";

/**
 * MissionRolesPublicMemberExperience
 */
const MissionRolesPublicMemberExperience = () => (
  <div css={styles.container} id="about-mission">
    <NarrowContainer>
      <Grid gap={`2rem`} css={styles.inner_container}>
        <Grid.col start={4} end={10} css={styles.title_container}>          
          <Col>
            <MarketingHeader variant={colors.pinkPantherBase}>
              <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Header" />     
            </MarketingHeader>
            <H1 isPublic>
              <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Title" />            
            </H1>      
          </Col>     
        </Grid.col>
        <Grid.col start={3} end={11} css={styles.subtitle}>
          <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Subtitle" />
        </Grid.col>
        <Grid.col start={1} end={6}>
          <Col gap="1rem">            
            <CheckList css={styles.checklist} data={[
              <Col key="0" css={styles.item_container}>
                <MarketingHeader>
                  <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point1Title" />
                </MarketingHeader>
                <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point1Description" />
              </Col>,             
              <Col key="1" css={styles.item_container}>
                <MarketingHeader>
                  <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point2Title" />
                </MarketingHeader>
                <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point2Description" />
              </Col>,
              <Col key="2" css={styles.item_container}>
                <MarketingHeader>
                  <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point3Title" />
                </MarketingHeader>
                <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point3Description" />
              </Col>,
              <Col key="3" css={styles.item_container}>
                <MarketingHeader>
                  <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point4Title" />
                </MarketingHeader>
                <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point4Description" />
              </Col>,
              <Col key="4" css={styles.item_container}>
                <MarketingHeader>
                  <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point5Title" />
                </MarketingHeader>
                <FormattedMessage id="Missions.Roles.Public.MissionRolesPublicMemberExperience.Point5Description" />
              </Col>,
            ]}
            />           
          </Col>
        </Grid.col>
        <Grid.col start={6} end={13} css={styles.image_container}>
          <Image url={Hero} alt={getBrandConfig().name} css={styles.image} />
        </Grid.col>
      </Grid>
    </NarrowContainer>
  </div>
);

const styles = {
  container: css`
    color: ${colors.grayAnatomyDark};
    background: ${colors.white} url(${Background}) no-repeat center center;
    padding: 14rem 0 14rem 0;
    background-size: 50%;
    background-position: right;

   @media (max-width: ${breakpoints.mobile}) {
      padding: 6rem 0 0rem 0;
      background:#fff; 
    }
  `,
  inner_container: css`
    @media (max-width: ${breakpoints.mobile}) {
      grid-column-gap: 2rem;
      grid-row-gap: 2rem;
    }
  `,
  checklist: css`
    color: ${colors.purpleRainBase};
  `,
  item_container: css`
    margin-bottom: 2rem;
    line-height: 1.5;
    margin-top: -0.4rem;
    color: ${colors.grayAnatomyBase};
  `,
  title_container: css`
    display:flex;
    align-items:center; 
    justify-content:center;
    text-align:center;

    @media (max-width: ${breakpoints.mobile}) {
      margin-bottom:0rem;
    }
  `,
  subtitle: css`
    font-weight:400;
    font-size: ${fontSize.large};
    line-height: 1.5;
    margin-bottom:8rem;
    text-align: center;
  `,
  image_container:css`
    max-width: 100%;
    overflow: hidden;
  `,
  image: css`
    width:100%;
    border-radius: 3rem;

     @media (max-width: ${breakpoints.mobile}) {
      transform: scale(1.6);
      margin-bottom: -10rem;
    }
  `,
};

export default MissionRolesPublicMemberExperience;
